import MutualUserResult from '../result/MutualUserResult';
import ServerFacade from '../network/ServerFacade';
import LogoutResult from '../result/LogoutResult';
import GetStripeSubscriptionResult from '../result/GetStripeSubscriptionResult';
import Config from '../model/config';
/**
 *  This class acts as an interface to log in a user
 *  It also has a method to parse the information contained in the photos
 *  belonging to a user
 */


class MutualDAO {

	static async getUserInstance(): Promise<MutualUserResult> {
		const response = await ServerFacade.getUserInstance();


		try {
			return new MutualUserResult(
				true,
				'Instance Gotten',
				response.id,
				response.first_name,
				response.last_name,
				response.photos[0].url_hd,
				response.p_enabled

			);
		} catch {
			return new MutualUserResult(
				false,
				'Error getting instance',
				'-1',
				'none',
				'none',
				'none',
				false
			);
		}
	}

	// logoutResponse could either be true or false, depending if the user was logged out or not
	static async userLogout(): Promise<LogoutResult> {
		const logoutResponse = await ServerFacade.userLogout();

		try{
			if(logoutResponse.status === 200){
				return new LogoutResult(true, 'Logout Successful', true)
			}
			else{
				return new LogoutResult(false, 'Logout Unsucessful', false)
			}
		}
		catch{
			return new LogoutResult(false, 'Logout Unsucessful', false)
		}
	}

	static async getActiveSubscription(id : string): Promise<GetStripeSubscriptionResult> {
		const activeSubscription = await ServerFacade.getActiveSubscription(id);

		try{
			if(activeSubscription.active_subscription === null){
				return new GetStripeSubscriptionResult(true, 'Success', null)
			}
			return new GetStripeSubscriptionResult(true, 'Success', activeSubscription.active_subscription)
		}
		catch(error){
			console.log(error)
			return new GetStripeSubscriptionResult(false, 'Failed', null)

		}
	}

	static async getConfigs(): Promise<Config> {
		// TODO: Remove mock data - testing locally
		const mockResponse = [
			{
				"module": "premium-site",
				"timeBasedConfigs": [
					{
						"name": "pioneer",
						"startDate": "2026-07-17T06:01:00Z",
						"endDate": "2026-07-25T05:59:59Z",
						"theme": {
							"lockupLogoName": "",
							"name": "pioneer",
							"title": "Pioneer Day Sale",
							"subtitle": "Upgrade your chances with Premium!",
							"mobileTitle": "",
							"timer": { "isEnabled": true, "text": "" },
							"bannerName": { "mobile": "banner.png", "desktop": "banner.png" },
							"bodyBackgroundColor": "",
							"reStyled": { "borderRadius": 0, "backgroundColor": "", "color": "", "border": "", "boxShadow": "" },
							"puchaseButtonBackgroundColor": "",
							"billingTextColor": "",
							"monthlyTextColor": ""
						},
						"productList": [
							{ "item": "12 Months", "tag": "Best Value", "months": "12", "perMonth": "$7.50", "discountText": "monthly", "crossedPrice": "", "price": "$89.99", "percentOff": 70, "productValue": "mutual:subscription:renewable:12month" },
							{ "item": "6 Months", "tag": "Most Popular", "months": "6", "perMonth": "$8.33", "discountText": "monthly", "crossedPrice": "", "price": "$49.99", "percentOff": 65, "productValue": "mutual:subscription:renewable:6month" },
							{ "item": "3 Months", "months": "3", "perMonth": "$12.00", "crossedPrice": "", "discountText": "monthly", "price": "$35.99", "percentOff": 50, "productValue": "mutual:subscription:renewable:3month" },
							{ "item": "1 Month", "months": "1", "perMonth": "$19.99", "crossedPrice": "", "discountText": "", "price": "$19.99", "percentOff": 20, "productValue": "mutual:subscription:renewable:1month" }
						]
					},
					{
						"name": "pioneer",
						"startDate": "2026-07-25T06:01:00Z",
						"endDate": "2026-07-29T05:59:59Z",
						"theme": {
							"lockupLogoName": "",
							"name": "pioneer",
							"title": "Pioneer Day Sale",
							"subtitle": "Upgrade your chances with Premium!",
							"mobileTitle": "",
							"timer": { "isEnabled": true, "text": "" },
							"bannerName": { "mobile": "banner.png", "desktop": "banner.png" },
							"bodyBackgroundColor": "",
							"reStyled": { "borderRadius": 0, "backgroundColor": "", "color": "", "border": "", "boxShadow": "" },
							"puchaseButtonBackgroundColor": "",
							"billingTextColor": "",
							"monthlyTextColor": ""
						},
						"productList": [
							{ "item": "12 Months", "tag": "Best Value", "months": "12", "perMonth": "$7.50", "discountText": "monthly", "crossedPrice": "", "price": "$89.99", "percentOff": 70, "productValue": "mutual:subscription:renewable:12month" },
							{ "item": "6 Months", "tag": "Most Popular", "months": "6", "perMonth": "$8.33", "discountText": "monthly", "crossedPrice": "", "price": "$49.99", "percentOff": 65, "productValue": "mutual:subscription:renewable:6month" },
							{ "item": "3 Months", "months": "3", "perMonth": "$12.00", "crossedPrice": "", "discountText": "monthly", "price": "$35.99", "percentOff": 50, "productValue": "mutual:subscription:renewable:3month" },
							{ "item": "1 Month", "months": "1", "perMonth": "$19.99", "crossedPrice": "", "discountText": "", "price": "$19.99", "percentOff": 20, "productValue": "mutual:subscription:renewable:1month" }
						]
					}
				],
				"configs": []
			}
		];
		const premiumConfig = mockResponse.find((c: any) => c.module === 'premium-site');
		const config = new Config();
		if (premiumConfig) {
			const now = new Date();
			const activeEvent = premiumConfig.timeBasedConfigs.find((e: any) => new Date(e.startDate) <= now && now <= new Date(e.endDate));
			if (activeEvent) {
				config.currentEvent = {
					startDate: new Date(activeEvent.startDate),
					endDate: new Date(activeEvent.endDate),
					name: activeEvent.name,
					theme: activeEvent.theme,
					productList: activeEvent.productList,
				};
			}
			config.configs = premiumConfig.configs;
		}
		return config;
	}

}

export default MutualDAO;
